import { createFileRoute } from '@tanstack/react-router'
import { UserRole } from '@depanneo/types'
import { requiredRoles } from '@/shared/utils/require-roles'
import Technicians from '@/pages/technicians/main'

export type TechniciansSearch = {
  page?: string
  companyName?: string
  jobTypes?: string
  flags?: string
  postalCode?: string
  radiusKm?: string
  department?: string
}

export const Route = createFileRoute('/_authenticated/org/$orgId/technicians/')(
  {
    component: Technicians,
    validateSearch: (search: Record<string, unknown>): TechniciansSearch => {
      const {
        page,
        companyName,
        jobTypes,
        flags,
        postalCode,
        radiusKm,
        department,
      } = search

      return {
        page:
          typeof page === 'string'
            ? page
            : typeof page === 'number'
              ? String(page)
              : undefined,
        companyName: typeof companyName === 'string' ? companyName : undefined,
        jobTypes: typeof jobTypes === 'string' ? jobTypes : undefined,
        flags: typeof flags === 'string' ? flags : undefined,
        postalCode: typeof postalCode === 'string' ? postalCode : undefined,
        radiusKm: typeof radiusKm === 'string' ? radiusKm : undefined,
        department: typeof department === 'string' ? department : undefined,
      }
    },
    beforeLoad() {
      requiredRoles([UserRole.SUPER_ADMIN])
    },
  }
)
